/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable no-promise-executor-return */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useRef, useState } from "react";
import { Box, Tooltip } from "@mui/material";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import TextField from "@mui/material/TextField";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch } from "react-redux";
import SendIcon from "@mui/icons-material/Send";
import EmailIcon from "@mui/icons-material/Email";
import dayjs from "dayjs";
import * as Sentry from "@sentry/react";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import Heading from "../../components/Layout/Heading/NewHeading";
import { OuterContainerStyles } from "../../components/Layout/Typography";
import GenericTable from "./MemberSearch/Components/GenericTable";
import { SERVICES } from "../../components/Layout/Services";
import { SERVICES as MasterDataServices } from "../../components/Layout/Services/MasterDataServices";
import { get, post } from "../../components/Layout/ApiHandler/apihandler";
import AutoCompleteDropdown from "../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
import InputField from "../../components/Layout/fieldInput/InputField";
import Button from "../../components/Layout/Button/index";
import BasicDatePicker from "../../components/DatePicker/BasicDatePickerV2";
import Loader from "../../components/Loader/Loader";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../contants";
import Alert from "./Components/Alert/index";
import ViewIcon from "../../components/Svg/ViewIcon";
import { updateSelectedContribution } from "../../Config/Redux/actions/updateContributionData";
import { setUserData } from "../../Config/Redux/actions/userActions";
import { ROUTES } from "../../components/Routes";
import ReceiptAlert from "./Components/Alert/ReceiptAlert";
import SendEmailAlert from "./Components/Alert/SendEmailAlert";
import MemberUpdateModal from "./Components/Alert/MemberUpdateModal";

const DEFAULT_PAGE_SIZE = 5;
const tableHeaders = [
  "Receipt Number",
  "Mode of Payment",
  "Amount",
  "Cheque/DD No.",
  "Contribution Date",
  "Status",
  "Uin Type",
  "Uin",
  "Actions",
];
const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));
const getOptionsForUin = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    label: opt[key].replace(/_/g, " "),
    value: opt[key],
  }));
function ContributionDetails() {
  const { memberId } = useParams();
  const [memberData, setMemberData] = useState({});
  const [memberUin, setMemberUin] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentOrders, setPaymentOrders] = useState({});
  const [paymentData, setData] = useState([]);
  const dispatch = useDispatch();
  // const [paymentMethods, setPaymentMethods] = useState([]);
  const paymentMethods = [
    { name: "CASH", value: "CASH" },
    { name: "CHEQUE", value: "CHEQUE" },
    { name: "DEMAND DRAFT", value: "DEMAND_DRAFT" },
  ];
  const uinType = [
    { name: "PAN CARD", value: "PAN_CARD" },
    { name: "AADHAR CARD", value: "AADHAR_CARD" },
    { name: "VOTER CARD", value: "VOTER_CARD" },
    { name: "DRIVING LICENSE", value: "DRIVING_LICENSE" },
    { name: "PASSPORT", value: "PASSPORT" },
  ];
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  // const [uinType, setUinType] = useState([]);
  const [selectedUinType, setSelectedUinType] = useState("");
  const [payableCity, setPayableCity] = useState([]);
  const [selectedPayableCity, setSelectedPayableCity] = useState("");
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [selectedReceiptType, setSelectedReceiptType] = useState("");
  const [bankTypes, setBankTypes] = useState([]);
  const [selectedBankType, setSelectedBankType] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [amountValue, setAmountValue] = useState("");
  const [uinValue, setUinValue] = useState("");
  const [chequeDDNo, setChequeDDNo] = useState("");
  const [otherBank, setOtherBank] = useState("");
  const [openAlert, setOpenAlert] = useState(false);
  const [receiptAlert, setReceiptAlert] = useState(false);
  const [defaultReceiptData, setDefaultReceitData] = useState([]);
  const [paymentOrderId, setPaymentOrderId] = useState("");
  const [paymentOrderIdForEmail, setPaymentOrderIdForEmail] = useState("");
  const [selectedBankName, setSelectedBankName] = useState("");
  const [selectedPayableCityName, setSelectedPayableCityName] = useState("");
  const [selectedDonationPurposeName, setSelectedDonationPurposeName] =
    useState("");
  // const [isLoading, setIsLoading] = useState(false);
  const [resData, setResData] = useState({});
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const today = new Date();
  const threeDaysLater = new Date();
  threeDaysLater.setDate(today.getDate() + 2);
  const toast = useContext(ToastAlertContext);
  const navigate = useNavigate();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const inputRef = useRef(null);
  const [profileData, setProfileData] = useState({});

  const handleAlertClose = () => {
    setOpenAlert(false);
  };
  const handleReceiptAlert = () => {
    setReceiptAlert(false);
  };
  const handleEmailAlert = () => {
    setConfirmModalOpen(false);
  };
  const handleUpdateModal = () => {
    setUpdateModalOpen(false);
  };
  const handleDateChange = (date) => {
    const formattedDate = moment(date.$d).format("YYYY-MM-DDTHH:mm:ss");
    setSelectedDate(formattedDate);
  };
  const handleAmountChange = (value) => {
    setAmountValue(value);
  };
  const handleUinValue = (value) => {
    setUinValue(value);
  };
  const handleChequeDDNo = (value) => {
    setChequeDDNo(value);
  };
  const handleOtherBanks = (value) => {
    setOtherBank(value);
  };
  const getUserProfile = async () => {
    try {
      setIsLoading(true);
      const url = `${SERVICES.GET_MEMBER}/${memberId}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setMemberData(data.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      } else {
        console.error("Failed to fetch Division Type data");
        setIsLoading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
  };
  const getMemberUin = async () => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/uin`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setMemberUin(data.data);
        setUinValue(data?.data[0]?.uin);
        setSelectedUinType(data?.data[0]?.uinType);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const getMemberUinOnChange = async (uinType) => {
    // console.log("line 152", uinType);
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/uin`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setMemberUin(data.data);
        const selectedUinEntry = data.data.find(
          (entry) => entry.uinType === uinType,
        );
        // console.log("line 162", selectedUinEntry);
        if (selectedUinEntry) {
          setUinValue(selectedUinEntry?.uin);
          setSelectedUinType(selectedUinEntry?.uinType);
        } else {
          setUinValue("");
          console.error("No data found for the selected UIN type");
        }
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  // const handlePaymentMethod = async () => {
  //   try {
  //     const url = `${SERVICES.PAYMENT_METHODS}`;
  //     const response = await get(url);
  //     if (response.ok) {
  //       const data = await response.json();
  //       setPaymentMethods(data.data);
  //     }
  //   } catch (error) {
  //     console.error("Error", error);
  //   }
  // };
  // const handleUinType = async () => {
  //   try {
  //     const url = `${SERVICES.UIN_TYPES}`;
  //     const response = await get(url);
  //     if (response.ok) {
  //       const data = await response.json();
  //       setUinType(data.data);
  //     }
  //   } catch (error) {
  //     console.error("Error", error);
  //   }
  // };
  const handlePayableCity = async () => {
    try {
      const url = `${MasterDataServices.GET_PAYABLE_CITIES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setPayableCity(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleReceiptTypes = async () => {
    try {
      const url = `${SERVICES.RECEIPT_TYPES}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setReceiptTypes(data.data.receiptTypes);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleBankTypes = async () => {
    try {
      const url = `${SERVICES.GET_BSG_BANKS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setBankTypes(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const getDefaultReceipt = async () => {
    // try {
    //   const url = `${SERVICES.CONTRIBUTION_CYCLE}?size=200`;
    //   const response = await get(url);
    //   if (response.ok) {
    //     const data = await response.json();
    //     // console.log("line 268", data?.data?.content[0]?.receiptTypeList[0]?.id);
    //     setDefaultReceitData(data.data.content);
    //     const activeItem = data?.data?.content.find(
    //       (item) => item.status === "ACTIVE",
    //     );
    //     if (activeItem) {
    //       const { receiptTypeList } = activeItem;
    //       if (receiptTypeList.length > 0) {
    //         const idFromReceiptTypeList = receiptTypeList[0]?.id;
    //         setSelectedReceiptType(idFromReceiptTypeList);
    //       }
    //     }
    //   }
    // } catch (error) {
    //   Sentry.captureException(error);
    // }
    try {
      const url = `${SERVICES.CONTRIBUTION_CYCLE}/defaultDonationPurpose`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // setSelectedReceiptType(data.data);
        setSelectedReceiptType(data?.data?.id);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const getPaymentOrders = async () => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/paymentOrders?size=${DEFAULT_PAGE_SIZE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setPaymentOrders(data.data);
        setPaymentOrderId(data.data.content[0]?.id);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleViewReceipt = async (paymentOrderId) => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/paymentOrders/${paymentOrderId}/receipt`;
      const response = await get(url);

      if (response && response.ok) {
        // Handle the successful response as needed
        const receiptData = await response.json();
        // console.log("Receipt Data:", receiptData);
        const redirect = receiptData.data;
        if (redirect) {
          // setOpenAlert(false);
          setReceiptAlert(false);
          navigate("/contributionadmin/members/memberSearch");
          window.open(redirect, "_blank");
        }
      } else {
        console.error("Failed to fetch receipt data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleViewPrintReceipt = async (paymentOrderId) => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/paymentOrders/${paymentOrderId}/receipt`;
      const response = await get(url);

      if (response && response.ok) {
        // console.log("Ok");
        // Handle the successful response as needed
        const receiptData = await response.json();
        // console.log("Receipt Data:", receiptData);
        const redirect = receiptData.data;
        // console.log(redirect);
        if (redirect) {
          // setOpenAlert(false);
          // setUrl(redirect);
          // setPrintAlert(true);
          setReceiptAlert(false);
          // window.open(redirect, "_blank").print();
          // setTimeout(() => {
          //   window.print();
          // }, 1000);
          // const newWindow = window.open(redirect, "_blank");
          // newWindow.window.print();
          // newWindow.print();
          // setTimeout(() => {
          //   newTab.print();
          // }, 5000);
          const newTab = window.open(redirect, "_blank");
          setTimeout(() => {
            newTab.print();
          }, 5000);
          // newTab.onload = () => {
          //   window.print();
          // };
          // const newTab = window.open(redirect, "_blank");
          // newTab.addEventListener("load", () => {
          //   setTimeout(() => {
          //     newTab.print();
          //   }, 1000);
          // });
        }
      } else {
        console.error("Failed to fetch receipt data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handleViewReceiptForTable = async (paymentOrderId) => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/paymentOrders/${paymentOrderId}/receipt`;
      const response = await get(url);

      if (response && response.ok) {
        // Handle the successful response as needed
        const receiptData = await response.json();
        // console.log("Receipt Data:", receiptData);
        const redirect = receiptData.data;
        // setReceiptAlert(false);
        if (redirect) {
          window.open(redirect, "_blank");
        }
      } else {
        console.error("Failed to fetch receipt data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const sendEmail = (paymentOrderId) => {
    setConfirmModalOpen(true);
    setPaymentOrderIdForEmail(paymentOrderId);
    // setConfirmModalOpen(true);
  };
  const handleSendEmail = async (paymentOrderId) => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/paymentOrders/${paymentOrderId}/sendReceiptByEmail`;
      const response = await post(url);

      if (response && response.ok) {
        // alert("Email Sent Successfully");
        // console.log("success");
        toast.show("Email Sent Successfully", AlertStatus.SUCCESS);
        setConfirmModalOpen(false);
        navigate("/contributionadmin/members/memberSearch");
      } else {
        toast.show("Something Went Wrong", AlertStatus.ERROR);
        // console.error("Failed to fetch receipt data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/paymentOrders?page=${selectedPage}&size=${DEFAULT_PAGE_SIZE}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setPaymentOrders(data.data);
      } else {
        console.error("Failed to fetch contribution data");
        setIsLoading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const validateContributionDetails = () => {
    if (!selectedPaymentMethod) {
      toast.show("Please Select Payment Method", AlertStatus.ERROR);
      return false;
    }
    if (!amountValue) {
      toast.show("Please Select Amount", AlertStatus.ERROR);
      return false;
    }
    // Check for CASH payment method and validate amount
    if (selectedPaymentMethod === "CASH") {
      const amountIsMultipleOf50 = amountValue % 50 === 0;
      const amountIsGreaterThan2000 = amountValue > 2000;
      if (!amountIsMultipleOf50) {
        toast.show(
          "The cash payment amount must be in multiples of 50.",
          AlertStatus.ERROR,
        );
        return false;
      }
      if (amountIsGreaterThan2000) {
        toast.show(
          "Cash contribution limit is ₹2,000 only.",
          AlertStatus.ERROR,
        );
        return false;
      }
    }
    if (!selectedUinType) {
      toast.show("Please Select Uin Type", AlertStatus.ERROR);
      return false;
    }
    if (
      selectedUinType === "PAN_CARD" &&
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid PAN.\nFor Example: XXXXX9999X`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (
      selectedUinType === "AADHAR_CARD" &&
      !/^[2-9]{1}[0-9]{11}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid Aadhaar Number.\nFor Example 999999999999`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (
      selectedUinType === "VOTER_CARD" &&
      !/^[a-zA-Z0-9 -]{5,20}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid Elector's Photo Identity Number.`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (
      selectedUinType === "DRIVING_LICENSE" &&
      !/^[a-zA-Z0-9 -]{5,20}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid Driving License Number.`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (
      selectedUinType === "PASSPORT" &&
      !/^[A-Z]{1}[0-9]{7}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid Passport Number.\nFor Example JXXXXXXX`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (!selectedReceiptType) {
      toast.show("Please Select Donation Purpose", AlertStatus.ERROR);
      return false;
    }
    if (
      (selectedPaymentMethod === "CHEQUE" ||
        selectedPaymentMethod === "DEMAND_DRAFT") &&
      !chequeDDNo
    ) {
      toast.show("Please Select Cheque/DD No.", AlertStatus.ERROR);
      return false;
    }
    if (
      (selectedPaymentMethod === "CHEQUE" ||
        selectedPaymentMethod === "DEMAND_DRAFT") &&
      !selectedDate
    ) {
      toast.show("Please Select Date", AlertStatus.ERROR);
      return false;
    }
    if (
      (selectedPaymentMethod === "CHEQUE" ||
        selectedPaymentMethod === "DEMAND_DRAFT") &&
      !selectedPayableCity
    ) {
      toast.show("Please Select Payable City", AlertStatus.ERROR);
      return false;
    }
    if (
      (selectedPaymentMethod === "CHEQUE" ||
        selectedPaymentMethod === "DEMAND_DRAFT") &&
      !selectedBankType
    ) {
      toast.show("Please Select Drawn on Bank", AlertStatus.ERROR);
      return false;
    }
    if (selectedBankName === "Other Bank" && !otherBank) {
      toast.show("Please Enter Other Bank", AlertStatus.ERROR);
      return false;
    }
    return true;
  };
  const resetForm = () => {
    setSelectedPaymentMethod("");
    setAmountValue("");
    setSelectedUinType("");
    setUinValue("");
    // setSelectedReceiptType("");
    setChequeDDNo("");
    setOtherBank("");
    setSelectedDate(null);
    setSelectedPayableCity("");
    setSelectedBankType("");
  };

  const openModal = () => {
    if (!validateContributionDetails()) {
      return;
    }
    setIsButtonDisabled(true);
    setOpenAlert(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 10000);
  };
  const handleSubmit = async () => {
    // if (!validateContributionDetails()) {
    //   return;
    // }
    setIsLoading(true);
    const formattedDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSS");
    const data = {
      fullName: memberData.fullName,
      orderPaymentMethod: selectedPaymentMethod,
      amount: Number(amountValue),
      uinType: selectedUinType,
      uin: uinValue,
      type: "ONE_TIME",
      status: "SUCCESS",
      source: "WEB",
      createdAt: formattedDate,
      paymentTransaction: {
        amount: Number(amountValue),
        paymentMethodType: selectedPaymentMethod,
        paymentGateway: null,
        status: "CAPTURED",
        cardLast4Digits: null,
        upiVpa: null,
        createdAt: formattedDate,
        chequeDate: selectedPaymentMethod === "CHEQUE" ? selectedDate : null,
        receiptNumber: null,
        receiptDate: null,
        chequeNumber: selectedPaymentMethod === "CHEQUE" ? chequeDDNo : null,
        ddDate: selectedPaymentMethod === "DEMAND_DRAFT" ? selectedDate : null,
        ddNumber: selectedPaymentMethod === "DEMAND_DRAFT" ? chequeDDNo : null,
        otherBankName: otherBank || null,
        drawnBankId: selectedBankType || null,
      },
      donationPurpose: selectedReceiptType,
      payableCityId: selectedPayableCity || null,
      payableCityName: null,
      bankId: null,
      bankName: null,
    };
    const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/paymentOrders`;
    try {
      const response = await post(url, data);
      if (response.ok) {
        const res = await response.json();
        // await fetchBankData();
        setResData(res?.data);
        toast.show("Details Added Successfully", AlertStatus.SUCCESS);
        await getPaymentOrders();
        resetForm();
        setTimeout(() => {
          setReceiptAlert(true);
        }, 1000);
        // setOpenAlert(true);
      } else {
        const errorData = await response.json();
        toast.show(errorData.message, AlertStatus.ERROR);
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
      setOpenAlert(false);
    }
    const uinData = {
      memberId,
      uin: uinValue,
      uinType: selectedUinType,
    };
    const uinUrl = `${SERVICES.GET_MEMBER_DETAILS}/updateUin`;
    try {
      const response = await post(uinUrl, uinData);
      if (response.ok) {
        const res = await response.json();
        // console.log(res);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
    // setOpenAlert(false);
    // setReceiptAlert(true);
  };
  useEffect(() => {
    if (paymentOrders.content) {
      const updatedTableData = paymentOrders.content.map((item) => {
        // console.log("line no 378", paymentOrders.content);
        const formattedDate = moment(item?.createdAt).format("DD/MM/YYYY");
        return {
          "Receipt Number":
            item?.paymentTransaction?.externalReceiptNumber?.replace(/_/g, " "),
          "Mode of Payment":
            item?.paymentTransaction?.paymentMethodType?.replace(/_/g, " "),
          Amount:
            item.status === "CANCELLED" ? (
              <s>{item?.amount ? `${item.amount.toString()}.00` : ""}</s>
            ) : (
              <p>{item?.amount ? `${item.amount.toString()}.00` : ""}</p>
            ),
          "Cheque/DD No.":
            item?.paymentTransaction?.chequeNumber ??
            item?.paymentTransaction?.ddNumber ??
            "",
          "Contribution Date": formattedDate,
          Status: item?.status,
          "Uin Type": item?.uinType.replace(/_/g, " "),
          Uin: item?.uin,
          Actions: (
            <Box sx={{ display: "flex", gap: "10px" }}>
              {profileData?.assignedRoles?.includes("contributionAdmin") && (
                <Tooltip title="Update Contribution" placement="top">
                  <div>
                    <EditIcon
                      sx={{ fontSize: "medium", cursor: "pointer" }}
                      onClick={async () => {
                        dispatch(setUserData(memberData));
                        dispatch(updateSelectedContribution(item));
                        await navigate(
                          `${ROUTES.MEMBER_CONTRIBUTION_UPDATE}/${memberId}/${item?.id}`,
                        );
                      }}
                    />
                  </div>
                </Tooltip>
              )}
              {/* {item?.paymentTransaction?.receiptCancelledFlag === false && (
                <Tooltip title="View Receipt" placement="top">
                  <div>
                    <ViewIcon
                      style={{ cursor: "pointer", textAlign: "cenetr" }}
                      onClick={() => handleViewReceiptForTable(item?.id)}
                    />
                  </div>
                </Tooltip>
              )} */}
              {item?.status === "SUCCESS" && (
                <Tooltip title="View Receipt" placement="top">
                  <div>
                    <ViewIcon
                      style={{ cursor: "pointer", textAlign: "cenetr" }}
                      onClick={() => handleViewReceiptForTable(item?.id)}
                    />
                  </div>
                </Tooltip>
              )}
              {item?.status === "SUCCESS" && (
                <Tooltip title="Send Email" placement="top">
                  <div>
                    <EmailIcon
                      sx={{ fontSize: "medium", cursor: "pointer" }}
                      onClick={() => sendEmail(item?.id)}
                    />
                  </div>
                </Tooltip>
              )}
              {/* <ViewIcon
                style={{ cursor: "pointer", textAlign: "cenetr" }}
                onClick={() => handleViewReceiptForTable(item?.id)}
              /> */}
            </Box>
          ),
        };
      });

      setData(updatedTableData);
    }
  }, [paymentOrders.content]);
  useEffect(() => {
    getUserProfile();
    getPaymentOrders();
    // handlePaymentMethod();
    // handleUinType();
    handlePayableCity();
    handleReceiptTypes();
    handleBankTypes();
    getDefaultReceipt();
    // getMemberUin();
  }, [memberId]);
  // console.log(selectedPaymentMethod);
  useEffect(() => {
    getMemberUin();
  }, []);
  const getUserRole = async () => {
    try {
      const url = `${SERVICES.GET_PROFILE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setProfileData(data.data);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  useEffect(() => {
    getUserRole();
  }, []);
  // useEffect(() => {
  //   let isMounted = true;
  //   if (selectedUinType) {
  //     getMemberUinOnChange();
  //   }
  //   return () => {
  //     isMounted = false;
  //     setUinValue("");
  //   };
  // }, [selectedUinType, memberId]);
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      openModal();
    }
  };
  return (
    <div
      style={{ width: "100%", overflow: "hidden", outline: "none" }}
      tabIndex="0" // Make the div focusable
      onKeyPress={handleKeyPress}
    >
      <PageSyncCal />
      <Heading title="Contribution Details" />
      <OuterContainerStyles
        marginTop="24px"
        marginBottom="24px"
        style={{ padding: "24px" }}
      >
        <OuterCard>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Organization Structure
          </OuterCardHeading>
          <OuterCardText>
            {`${memberData.areaName || "NA"} / ${
              memberData.clusterName || "NA"
            }  / ${memberData.zoneName || "NA"} 
            / ${memberData.regionName || "NA"} / ${
              memberData.chapterName || "NA"
            } / ${memberData.districtName || "NA"} / ${
              memberData.blockName || "NA"
            }`}
          </OuterCardText>
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Member Details
          </OuterCardHeading>
          <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>Member Name</MemberDetailsTextHeading>
            <MemberDetailsText>{memberData.fullName}</MemberDetailsText>
            {profileData?.assignedRoles?.includes("contributionAdmin") && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-end",
                  marginLeft: "auto",
                }}
              >
                <Tooltip title="Update Member Name" placement="top">
                  <EditIcon
                    sx={{ fontSize: "medium", cursor: "pointer" }}
                    onClick={() => setUpdateModalOpen(true)}
                  />
                </Tooltip>
              </Box>
            )}
          </MemberDetailsDiv>
          <MemberDetailsDiv2>
            <MemberDetailsTextHeading>Address</MemberDetailsTextHeading>
            <MemberDetailsText>{memberData.addressLine1}</MemberDetailsText>
          </MemberDetailsDiv2>
          <MemberDetailsDiv>
            <MemberDetailsTextHeading>Contact Info</MemberDetailsTextHeading>
            <MemberDetailsText>
              {`${memberData.emailId}  /  ${memberData.mobileNumber}`}
            </MemberDetailsText>
          </MemberDetailsDiv>
          {/* <MemberDetailsDiv2 largePadding>
            <MemberDetailsTextHeading>Gohonzon Member</MemberDetailsTextHeading>
            <MemberDetailsText>
              {" "}
              {memberData.gohonzonMemberships &&
              memberData.gohonzonMemberships.length > 0
                ? memberData.gohonzonMemberships[0].type
                : "No"}
            </MemberDetailsText>
          </MemberDetailsDiv2> */}
          <MemberDetailsDiv2 largePadding>
            <MemberDetailsTextHeading>
              Division/Sub Division
            </MemberDetailsTextHeading>
            <MemberDetailsText> {memberData?.divisionName}</MemberDetailsText>
          </MemberDetailsDiv2>
          {/* <MemberDetailsDiv largePadding>
            <MemberDetailsTextHeading>
              Contribution Collection to Deposit
            </MemberDetailsTextHeading>
            <MemberDetailsText>Yes Bank</MemberDetailsText>
          </MemberDetailsDiv> */}
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Existing Contribution Details
          </OuterCardHeading>
          {paymentData.length > 0 ? (
            <Box sx={{ width: "100%" }}>
              <GenericTable
                tableData={paymentData}
                data={paymentOrders}
                headers={tableHeaders}
                onPageChange={handlePageChange}
              />
            </Box>
          ) : (
            <NodataText>No existing contribution details found.</NodataText>
          )}
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Contribution Details
          </OuterCardHeading>
          <FieldsDiv>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              options={getOptions(paymentMethods, "value")}
              label="Payment Method"
              name="paymentMethods"
              value={selectedPaymentMethod}
              onChange={(selectedValue) => {
                setSelectedPaymentMethod(selectedValue?.value);
              }}
              inputProps={{
                required: true,
              }}
              useHiddenInput
              style={{ width: "350px" }}
            />
            <InputField
              label="Amount"
              name="amount"
              required
              value={amountValue}
              onChange={(event) => {
                const { value } = event.target;
                if (/^\d*$/.test(value)) {
                  handleAmountChange(value);
                }
              }}
              style={{ width: "350px" }}
            />
          </FieldsDiv>
          <FieldsDiv>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              options={getOptionsForUin(uinType, "value")}
              label="Uin Type"
              name="uinType"
              value={selectedUinType}
              onChange={(selectedValue) => {
                setSelectedUinType(selectedValue?.value);
                getMemberUinOnChange(selectedValue?.value);
              }}
              inputProps={{ required: true }}
              useHiddenInput
              style={{ width: "350px" }}
            />
            <InputField
              label="Uin No."
              name="amount"
              value={uinValue}
              onChange={(event) => {
                const { value } = event.target;
                handleUinValue(value);
              }}
              required
              style={{ width: "350px" }}
            />
          </FieldsDiv>
          <FieldsDiv>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              options={getOptions(receiptTypes, "id")}
              label="Donation Purpose"
              name="receiptTypes"
              value={selectedReceiptType}
              onChange={(selectedValue) => {
                setSelectedReceiptType(selectedValue?.value);
                setSelectedDonationPurposeName(selectedValue?.name);
              }}
              inputProps={{ required: true }}
              useHiddenInput
              style={{ width: "350px" }}
              disabled
            />
            <TextField
              id="outlined-multiline-static"
              label="Remarks"
              multiline
              rows={2}
              // defaultValue="Default Value"
              sx={{ width: "350px", backgroundColor: "white" }}
            />
          </FieldsDiv>
        </OuterCard>
        <OuterCard style={{ marginTop: "24px" }}>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            Cheque / DD Details (if any)
          </OuterCardHeading>
          <FieldsDiv>
            <InputField
              label="Cheque/DD No."
              // name="amount"
              inputProps={{
                maxLength: 6,
              }}
              value={chequeDDNo}
              onChange={(event) => {
                const { value } = event.target;
                handleChequeDDNo(value);
              }}
              disabled={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
              }
              style={{ width: "350px" }}
              required
            />
            <BasicDatePicker
              // useDefaultBorders
              label="DD/MM/YYYY"
              sx={{
                width: "350px",
                backgroundColor:
                  selectedPaymentMethod !== "CHEQUE" &&
                  selectedPaymentMethod !== "DEMAND_DRAFT"
                    ? "rgba(239, 239, 239, 1.5)"
                    : "white",
              }}
              onChange={handleDateChange}
              value={selectedDate}
              // minDate={dayjs(today)}
              maxDate={dayjs(threeDaysLater)}
              disabled={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
              }
              required
            />
          </FieldsDiv>
          <FieldsDiv>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.cityName}
              options={getOptions(payableCity, "id")}
              label="Payable City"
              name="payableCity"
              value={selectedPayableCity}
              onChange={(selectedValue) => {
                setSelectedPayableCity(selectedValue?.value);
                setSelectedPayableCityName(selectedValue?.cityName);
              }}
              disabled={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
              }
              inputProps={{ required: true }}
              useHiddenInput
              style={{ width: "350px" }}
            />
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.bankName}
              options={getOptions(bankTypes, "id")}
              label="Drawn on Bank"
              name="paymentMethods"
              value={selectedBankType}
              onChange={(selectedValue) => {
                setSelectedBankType(selectedValue?.value);
                setSelectedBankName(selectedValue?.bankName);
              }}
              disabled={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
              }
              inputProps={{ required: true }}
              useHiddenInput
              style={{ width: "350px" }}
            />
          </FieldsDiv>
          <FieldsDiv>
            <InputField
              label="Other Bank"
              // name="amount"
              onChange={(event) => {
                const { value } = event.target;
                handleOtherBanks(value);
              }}
              disabled={
                selectedPaymentMethod !== "CHEQUE" &&
                selectedPaymentMethod !== "DEMAND_DRAFT"
              }
              required={selectedBankName === "Other Bank"}
              style={{ width: "350px" }}
            />
            <Box sx={{ width: "350px" }} />
          </FieldsDiv>
        </OuterCard>
        <Footer>
          <FooterText>
            Please verify the contributor’s name. If you find any error, do not
            proceed. Contact your Region Stats In-charge for correction. Once
            you proceed, the name cannot be corrected in this financial year.
          </FooterText>
        </Footer>
        <ButtonContainer>
          <Button cancel onClick={() => navigate(-1)}>
            Cancel
          </Button>
          <Button onClick={openModal} disabled={isButtonDisabled}>
            Submit
          </Button>
        </ButtonContainer>
        {openAlert && (
          <Alert
            open={openAlert}
            onClose={handleAlertClose}
            onSubmit={() => handleSubmit()}
            memberName={memberData?.fullName}
            amount={amountValue}
            paymentMethod={selectedPaymentMethod}
            donationPurpose={selectedDonationPurposeName}
            chequeDDNo={chequeDDNo}
            payableCity={selectedPayableCityName}
            DrawnOnBank={selectedBankName}
            otherBank={otherBank}
          />
        )}
        <ReceiptAlert
          open={receiptAlert}
          ReceiptNumber={resData?.paymentTransaction?.externalReceiptNumber}
          onClose={handleReceiptAlert}
          onSubmit={() => handleViewReceipt(paymentOrderId)}
          onPrint={() => handleViewPrintReceipt(paymentOrderId)}
          onEmail={() => handleSendEmail(paymentOrderId)}
        />
        <SendEmailAlert
          open={confirmModalOpen}
          onClose={handleEmailAlert}
          onSubmit={() => handleSendEmail(paymentOrderIdForEmail)}
        />
        <MemberUpdateModal
          open={updateModalOpen}
          onClose={handleUpdateModal}
          memberName={memberData.fullName}
          getUserProfile={getUserProfile}
        />
      </OuterContainerStyles>
      {isLoading && <Loader />}
    </div>
  );
}

export default ContributionDetails;

const OuterCard = styled.div`
  display: flex;
  padding: 12px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #c5c5d1;
  background: #f5f5f5;
`;

const OuterCardHeading = styled.p`
  margin: 0;
  color: #000;
  //   font-family: Noto Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
const OuterCardText = styled.p`
  margin: 0;
  color: #484848;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
// const MemberDetailsDiv = styled.div`
//   display: flex;
//   // padding: 7px 24px;
//   padding: 16px 24px;
//   align-items: center;
//   gap: 8px;
//   align-self: stretch;
//   border: 1px solid #62b6da;
//   background: #fff;
// `;
const MemberDetailsDiv = styled.div`
  display: flex;
  padding: ${(props) => (props.largePadding ? "16px" : "7px")} 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: 1px solid #62b6da;
  background: #fff;
`;
const MemberDetailsDiv2 = styled.div`
  display: flex;
  padding: 7px 24px;
  // padding: 16px 24px;
  padding: ${(props) => (props.largePadding ? "16px" : "7px")} 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: 1px solid #62b6da;
  background: #e8f6fc;
`;
const MemberDetailsTextHeading = styled.p`
  margin: 0;
  width: 250px;
  color: #484848;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
`;
const MemberDetailsText = styled.p`
  margin: 0;
  width: 270px;
  color: #484848;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
`;
const FieldsDiv = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  gap: 146px;
  align-self: stretch;
`;

const Footer = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

const FooterText = styled.p`
  color: #e41717;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
`;

const ButtonContainer = styled.div`
  display: flex;
  padding: 24px 30px;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;
const NodataText = styled.p`
  color: #e41717;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
`;
